import { useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { EpisodeCard } from "@/components/podcast-episodes";
import { podcastEpisodesQuery } from "@/lib/podcast.functions";
import { archivedEpisodes, mergeEpisodes } from "@/lib/podcast";

export function PodcastSection() {
  const { data } = useQuery(podcastEpisodesQuery);
  const episodes = (data ?? mergeEpisodes(archivedEpisodes)).slice(0, 2);

  return (
    <section
      id="podcast"
      aria-labelledby="podcast-heading"
      className="scroll-mt-24 border-b border-ink/10 bg-steel-soft/40"
    >
      <div className="container-page section-pad">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-steel pb-5">
          <p className="text-sm font-medium text-coral-text">Podcast</p>
        </div>

        <div className="mt-8 grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
          <div>
            <h2 id="podcast-heading" className="display-xl text-4xl md:text-5xl">
              Soft Power.
              <span className="mt-3 block text-xl leading-snug md:text-2xl">
                Podcast o sile, która nie musi być głośna.
              </span>
            </h2>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-ink">
              Rozmowy z ludźmi, którzy zrobili coś więcej w biznesie, mediach i kulturze. Pytamy
              o decyzje, zwątpienie i to, co trzyma, kiedy sił już brak.
            </p>

            <div className="mt-6 border-t border-steel pt-5">
              <p className="text-sm font-medium text-ink">Prowadzące</p>
              <p className="mt-2 text-sm leading-relaxed text-ink-soft">
                Sylwia Sitkowska · Magdalena Kuszewska
              </p>
              <p className="mt-3 text-sm text-ink-soft">Realizacja: Zwierciadło</p>
            </div>
            <Button asChild className="mt-7 h-auto min-h-11 rounded-none px-5 py-3">
              <Link to="/podcast">
                Wszystkie odcinki <ArrowRight aria-hidden="true" />
              </Link>
            </Button>
          </div>

          <div className="grid gap-8 sm:grid-cols-2">
            {episodes.map((e) => (
              <EpisodeCard key={e.videoId} episode={e} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
